// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3d06a09d","90":"bc996bcf","188":"61091900","202":"3277e375","589":"e326e2a8","823":"529b5092","965":"f8b2f26b","976":"fa949ae6"}[chunkId] + ".chunk.js";
};